import { makeStyles } from '@material-ui/core/styles';

export const useBenefitsTitleStyles = makeStyles((theme) => ({
  container: {
    border: `2px dashed ${theme.palette.primary.main}`,
    width: '100%',
    borderRadius: 10,
    padding: 5,
    marginBottom: 40,
  },
  boxDesktop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  boxMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px 0px',
  },
  client: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
}));

export const useBenefitsFooterStyles = makeStyles(() => ({
  boxDesktop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '45px',
  },
  boxMobile: {
    display: 'grid',
    direction: 'column',
    rowGap: 20,
    '& > *': {
      marginBottom: 20,
      textAlign: 'center',
    },
  },
  textToRight: {
    textAlign: 'right',
  },
  lowerText: {
    fontSize: 12,
  },
  linkText: {
    fontSize: 16,
  },
}));

export const useBenefitStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
  },
  description: {
    fontSize: 16,
    textAlign: 'center',
  },
  container: {
    marginBottom: 30,
  },
  icon: {
    marginRight: 8,
  },
}));

export const useGoldenModalStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      padding: '0px 20px',
      borderRadius: 10,
    },
    '& > *': {
      textAlign: 'center',
    },
  },
  button: {
    margin: '23px 0px',
  },
  title: {
    fontSize: 20,
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  image: {
    height: 70,
    width: 59,
  },
}));

export const useBenefitsListStyles = makeStyles(() => ({
  divider: {
    '&.MuiDivider-root': {
      backgroundColor: '#ababab',
    },
    marginBottom: 20,
  },
}));
